export default __webpack_public_path__ + "static/media/call.c0dffad0.svg";